import * as yup from 'yup';

import { validatePassword, validateConfirmPassword } from 'schema/validation/password';

export const SignUpSchema = yup.object().shape({
    email: yup.string().required('Email Address is required'),
    password: yup.string().test('Password validation', validatePassword),
    passwordConfirm: yup.string().test('Password Confirm Matches', validateConfirmPassword)
});
